<template>
  <div class="product-ccard-container">
    <div class="title">卡金会员</div>
    <div class="common-search-wrap">
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form size="small" ref="searchForm" :model="searchForm">
            <el-form-item label="门店" prop="store_id">
              <el-select size="small" v-model="searchForm.storeId" placeholder="请选择" filterable clearable
                         @change="handleQuery">
                <el-option-group
                  v-for="group in stores"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" style="text-align: right">
          <el-button type="primary" size="small" @click="handleAdd">添加卡金</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background:'#F2F2F4'}"
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="name" label="卡金名称" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="storeNames" label="所属门店"></el-table-column>
      <el-table-column prop="type" label="卡金类型">
        <template #default="{ row }">
          <el-tag size="small" type="success" v-if="row.type === 1">普通卡金</el-tag>
          <el-tag size="small" type="warning" v-else>企业卡金</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="闲时优惠">
        <template #default="{ row }">
          <el-tag size="small" v-if="row.leisure === 1">开启</el-tag>
          <el-tag size="small" type="info" v-else>关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="创建时间"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template #default="{ row }">
          <el-link
            style="margin-right: 15px"
            type="primary"
            @click="handleEdit(row.id)"
          >
            编辑
          </el-link>
          <el-link
            :type="row.status === 1 ? 'danger' : 'success'"
            @click="handleStatus(row)"
          >
            {{ row.status === 1 ? '下架' : '上架' }}
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        background
        :current-page="curPage"
        layout="total, prev, pager, next, jumper"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchForm: {
        storeId: '',
      },
      tableData: [],
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 20,
      /*是否加载完成*/
      loading: true,
      addOrUpdateVisible: false,
      detailVisible: false,
      /*门店列表*/
      stores: [],
    }
  },
  created() {
    this.fetchStore()
    this.fetchData()
  },
  methods: {
    fetchStore() {
      this.$http.get("store/list").then(({data}) => {
        let storesBusiness = []
        let storesEnd = []
        data.data.forEach(ele => {
          const val = {value: ele.id, label: ele.title};
          if (ele.businessType === 1) {
            storesEnd.push(val) //结业门店
          } else {
            storesBusiness.push(val) //营业门店
          }
        })
        this.stores = [
          {
            label: '营业门店',
            options: storesBusiness
          },
          {
            label: '结业门店',
            options: storesEnd
          },
        ]
      })
    },
    fetchData() {
      let self = this
      let params = self.searchForm
      params.curPage = self.curPage
      params.pageSize = self.pageSize
      this.$http.get("cCard/page", {params}).then(({data}) => {
        this.tableData = data.records
        this.total = data.total
      })
      self.loading = false
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.fetchData()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.fetchData()
    },
    /*搜索查询*/
    handleQuery() {
      this.curPage = 1
      this.tableData = []
      this.fetchData()
    },
    handleAdd() {
      this.$router.push({path: '/addCcard'})
    },
    handleEdit(id) {
      this.$router.push({path: '/addCcard', query: {id}})
    },
    handleStatus(row) {
      let status = row.status === 1 ? 0 : 1
      this.$http.post("cCard/status", JSON.stringify({status, id: row.id})).then(({data}) => {
        this.$message.success("操作成功")
        this.fetchData()
      })
    }
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 1.17em;
}

.common-search-wrap, .pagination {
  padding-top: 20px;
}

.pagination {
  text-align: center;
}
</style>
